import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpHeaders} from '@angular/common/http';

@Component({
  selector: 'app-issue',
  templateUrl: './issue.component.html',
  styleUrls: ['./issue.component.css']
})
export class IssueComponent implements OnInit {

  issues: any;
  jira: any;
  jiraout: any;
  classification: any;

  constructor(private http: HttpClient) { }


  ngOnInit() {

    this.http.get('source/scan').subscribe(data => {

    });

    setTimeout(()=> {this.http.get('/issue/api/byclassstatus/0').subscribe(data => {
      this.issues = data;
    });}, 500);



  }



  classify() {



    for (const issue of this.issues) {


      this.http.get(encodeURI('/engine/classify/' + issue.Description)).subscribe(data => {
        this.classification = data;
        console.log(this.classification);

        this.http.get(encodeURI('issue/' + issue.issueID + '/' + this.classification.response)).subscribe(dddata => {

            for (let i = 0; i < this.issues.length; i++) {
              if (this.issues[i]._id === issue._id) {
                this.issues.splice(i, 1);
              }
            }
        });

         this.http.get(encodeURI('source/update/' + issue.issueID + '/' + this.classification.response.toString())).subscribe(ddata => {

            });


      });





    }





  }

}



// WEBPACK FOOTER //
// ./src/app/issue/issue.component.ts